import type { CatalogueCounty } from './types.js';

// U.S. Census Bureau TIGERweb ACS25 county catalogue.
export const PENNSYLVANIA_COUNTIES: readonly CatalogueCounty[] = [
  { name: "Adams", state: "PA", fips: "42001" },
  { name: "Allegheny", state: "PA", fips: "42003" },
  { name: "Armstrong", state: "PA", fips: "42005" },
  { name: "Beaver", state: "PA", fips: "42007" },
  { name: "Bedford", state: "PA", fips: "42009" },
  { name: "Berks", state: "PA", fips: "42011" },
  { name: "Blair", state: "PA", fips: "42013" },
  { name: "Bradford", state: "PA", fips: "42015" },
  { name: "Bucks", state: "PA", fips: "42017" },
  { name: "Butler", state: "PA", fips: "42019" },
  { name: "Cambria", state: "PA", fips: "42021" },
  { name: "Cameron", state: "PA", fips: "42023" },
  { name: "Carbon", state: "PA", fips: "42025" },
  { name: "Centre", state: "PA", fips: "42027" },
  { name: "Chester", state: "PA", fips: "42029" },
  { name: "Clarion", state: "PA", fips: "42031" },
  { name: "Clearfield", state: "PA", fips: "42033" },
  { name: "Clinton", state: "PA", fips: "42035" },
  { name: "Columbia", state: "PA", fips: "42037" },
  { name: "Crawford", state: "PA", fips: "42039" },
  { name: "Cumberland", state: "PA", fips: "42041" },
  { name: "Dauphin", state: "PA", fips: "42043" },
  { name: "Delaware", state: "PA", fips: "42045" },
  { name: "Elk", state: "PA", fips: "42047" },
  { name: "Erie", state: "PA", fips: "42049" },
  { name: "Fayette", state: "PA", fips: "42051" },
  { name: "Forest", state: "PA", fips: "42053" },
  { name: "Franklin", state: "PA", fips: "42055" },
  { name: "Fulton", state: "PA", fips: "42057" },
  { name: "Greene", state: "PA", fips: "42059" },
  { name: "Huntingdon", state: "PA", fips: "42061" },
  { name: "Indiana", state: "PA", fips: "42063" },
  { name: "Jefferson", state: "PA", fips: "42065" },
  { name: "Juniata", state: "PA", fips: "42067" },
  { name: "Lackawanna", state: "PA", fips: "42069" },
  { name: "Lancaster", state: "PA", fips: "42071" },
  { name: "Lawrence", state: "PA", fips: "42073" },
  { name: "Lebanon", state: "PA", fips: "42075" },
  { name: "Lehigh", state: "PA", fips: "42077" },
  { name: "Luzerne", state: "PA", fips: "42079" },
  { name: "Lycoming", state: "PA", fips: "42081" },
  { name: "McKean", state: "PA", fips: "42083" },
  { name: "Mercer", state: "PA", fips: "42085" },
  { name: "Mifflin", state: "PA", fips: "42087" },
  { name: "Monroe", state: "PA", fips: "42089" },
  { name: "Montgomery", state: "PA", fips: "42091" },
  { name: "Montour", state: "PA", fips: "42093" },
  { name: "Northampton", state: "PA", fips: "42095" },
  { name: "Northumberland", state: "PA", fips: "42097" },
  { name: "Perry", state: "PA", fips: "42099" },
  { name: "Philadelphia", state: "PA", fips: "42101" },
  { name: "Pike", state: "PA", fips: "42103" },
  { name: "Potter", state: "PA", fips: "42105" },
  { name: "Schuylkill", state: "PA", fips: "42107" },
  { name: "Snyder", state: "PA", fips: "42109" },
  { name: "Somerset", state: "PA", fips: "42111" },
  { name: "Sullivan", state: "PA", fips: "42113" },
  { name: "Susquehanna", state: "PA", fips: "42115" },
  { name: "Tioga", state: "PA", fips: "42117" },
  { name: "Union", state: "PA", fips: "42119" },
  { name: "Venango", state: "PA", fips: "42121" },
  { name: "Warren", state: "PA", fips: "42123" },
  { name: "Washington", state: "PA", fips: "42125" },
  { name: "Wayne", state: "PA", fips: "42127" },
  { name: "Westmoreland", state: "PA", fips: "42129" },
  { name: "Wyoming", state: "PA", fips: "42131" },
  { name: "York", state: "PA", fips: "42133" },
];
